import { render, staticRenderFns } from "./bi-apartment.vue?vue&type=template&id=4a67e532&scoped=true"
import script from "./bi-apartment.vue?vue&type=script&lang=js"
export * from "./bi-apartment.vue?vue&type=script&lang=js"
import style0 from "./bi-apartment.vue?vue&type=style&index=0&id=4a67e532&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a67e532",
  null
  
)

export default component.exports